import React from "react";
import { findArray } from 'helpers/utils'
import { useViewport } from 'components/general/useViewPort'
import Competitor from "components/presentation/Competitor";
import Label from "components/general/Label";
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";

const PreviousCompetitor = ({ data }) => {
    const { mirs_discipline } = useUrlFriendlyToParameters()
    const { breakPoint } = useViewport();
    let previousCompetitor = data?.results?.previousCompetitorResult
    let currentCompetitor = data?.results?.currentCompetitorResult

    let run1 = findArray(previousCompetitor?.extendedResults, { er_pos: ['RUN1'] }).er_irm
        ? findArray(previousCompetitor?.extendedResults, { er_pos: ['RUN1'] }).er_irm
        : findArray(previousCompetitor?.extendedResults, { er_pos: ['RUN1'] }).er_value

    let run2 = findArray(previousCompetitor?.extendedResults, { er_pos: ['RUN2'] }).er_irm
        ? findArray(previousCompetitor?.extendedResults, { er_pos: ['RUN2'] }).er_irm
        : findArray(previousCompetitor?.extendedResults, { er_pos: ['RUN2'] }).er_value

    let currentRun = findArray(data?.results?.extendedInfos, { ei_code: ['CURRENT_RUN'] }).ei_value

    let rank = previousCompetitor?.resultRank
        ? previousCompetitor?.resultRank
        : findArray(previousCompetitor?.extendedResults, { er_code: ['SCORE'] }).er_rank

    return (
        <>
            {previousCompetitor && currentCompetitor
                ?
                <>
                    <div className="fw-bold"><Label data={'LabelPrevComp'} /></div>
                    <table className="table">
                        <thead>
                            {breakPoint === "sm" || breakPoint === "xs"
                                ? <th scope="col"><Label data={'HeaderSO'} sport={mirs_discipline} /></th>
                                : <th scope="col"><Label data={'LabelStartOrder'} /></th>
                            }
                            <th className="w-80" scope="col"><Label data={'HeaderName'} /></th>
                            <th className="w-10" scope="col"></th>
                            <th className="w-5" scope="col"></th>
                        </thead>
                        <tbody>
                            {currentRun === '2'
                                ? <><tr>
                                    <td className='text-end' rowSpan='4'>{previousCompetitor?.startSortOrder}</td>
                                    <td rowSpan='4'><Competitor hidePicture={true} alwaysNoc={true} {...previousCompetitor?.participant} /></td>
                                    <td className="fw-bold"><Label data={'HeaderRun1'} mirs_discipline={mirs_discipline} />:</td>
                                    <td>{run1}</td>
                                </tr></>
                                : <><tr>
                                    <td className='text-end' rowSpan='2'>{previousCompetitor?.startSortOrder}</td>
                                    <td rowSpan='2'><Competitor hidePicture={true} alwaysNoc={true} {...previousCompetitor?.participant} /></td>
                                    <td className="fw-bold"><Label data={'HeaderRun1'} sport={mirs_discipline} />:</td>
                                    <td>{run1}</td>
                                </tr></>
                            }
                            {currentRun === '2'
                                ? <><tr>
                                    <td className="fw-bold"><Label data={'HeaderRun2'} sport={mirs_discipline} />:</td>
                                    <td>{run2}</td>
                                </tr></>
                                : <></>
                            }
                            {currentRun === '2'
                                ? <><tr>
                                    {data?.results?.eventUnitCode.includes('FNL')
                                        ? <td className="fw-bold"><Label data={'HeaderBest'} />:</td>
                                        : breakPoint === "sm" || breakPoint === "xs"
                                            ? <td className="fw-bold"><Label data={'HeaderAvg'} />.:</td>
                                            : <td className="fw-bold"><Label data={'HeaderAverageDesc'} />:</td>
                                    }
                                    <td>{previousCompetitor?.resultType === 'IRM' ? previousCompetitor?.resultIrm : previousCompetitor?.resultData}</td>
                                </tr></>
                                : <></>
                            }
                            <tr>
                                <td className="fw-bold"><Label data={'HeaderRank'} sport={mirs_discipline} />:</td>
                                <td>{rank}</td>
                            </tr>
                        </tbody>
                    </table>

                </>
                : <></>
            }
        </>
    )
}

export default PreviousCompetitor;